export default __webpack_public_path__ + "media/images/50-f4667ef9841a5af13821680a6496d9f2.jpg";